/**
 * Deze klasse handelt de login, de logica is als volgt:
 * login
 * als ok en nog geen spelend_user_session, laad deze session en ga naar fase 1, er is geen back naar fase 0
 * als ok en meerdere spelend_user_sessions, toon de lijst en laat eentje kiezen, ga naar fase 1, er is geen back naar fase 0
 *
 * aangezien de login afhandeling hier lokaal wordt gedaan wordt met een ref gewerkt ipv onChange afvangen
 *
 * @history
 * 20 september 2023
 * aanmaken account, wachtwoord vergeten
 *
 * 21 juli 2022
 * Start implementatie
 *
 */

import React from "react";

export class LoginPage extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                show_wachtwoord_vergeten: false,
                show_login_err: false,
                login_err_message: "",
                show_reset_err: false,
                reset_err_message: "",
                show_acc_err:false,
                acc_err_message:"",
                show_mode: "login"

            }

        this.inputEmail = React.createRef();
        this.inputPassword = React.createRef();

        this.resetEmail = React.createRef();

        this.accNaam = React.createRef();
        this.accEmail = React.createRef();
        this.accSchool = React.createRef();
       // this.accBrinnummer = React.createRef();
        this.accSchooltype = React.createRef();
        this.accGroep = React.createRef();
        this.accPlaats = React.createRef();
        this.accPassword1 = React.createRef();
        this.accPassword2 = React.createRef();



        this.loginClicked = this.loginClicked.bind(this);
        this.showResetClicked = this.showResetClicked.bind(this);
        this.showLoginClicked = this.showLoginClicked.bind(this);
        this.sendResetClicked = this.sendResetClicked.bind(this);
        this.sendAccClicked = this.sendAccClicked.bind(this);
        this.showAccClicked = this.showAccClicked.bind(this);

    }

    validateEmail(p_email)
    {
        return p_email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }

    showResetClicked()
    {
        this.setState({"show_reset_err": false, "show_login_err":false, "show_mode":"reset"});
    }

    showLoginClicked()
    {
        this.setState({ "show_login_err":false, "show_mode":"login"});
    }

    showAccClicked()
    {
        this.setState({ "show_acc_err":false, "show_mode":"acc"});
    }

    sendResetClicked()
    {
        if (!this.validateEmail(this.resetEmail.current.value))
        {
            this.setState({"show_reset_err": true, "reset_err_message": "Geen geldig e-mailadres ingevoerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_reset_err": false});


        const formData = new FormData();
        formData.append("email", this.resetEmail.current.value);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/reset_request", requestOptions)
            .then(response => response.json())
            .then(reset_json =>
            {
                if (reset_json.status == "err")
                {
                    this.setState({"show_reset_err": true, "reset_err_message": "Het resetten is niet gelukt. Probeer het opnieuw"});

                } else
                {
                    this.setState({'show_mode': "reset_send"});

                }
            });
    }

    loginClicked()
    {
        if (!this.validateEmail(this.inputEmail.current.value))
        {
            this.setState({"show_login_err": true, "login_err_message": "Geen geldig e-mailadres ingevoerd. Probeer het opnieuw"});
            return false;
        }

        if (this.inputPassword.current.value.length <= 6)
        {
            this.setState({"show_login_err": true, "login_err_message": "Geen geldig wachtwoord ingevoerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_login_err": false});

        const formData = new FormData();
        formData.append("email", this.inputEmail.current.value);
        formData.append("wachtwoord", this.inputPassword.current.value);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/login", requestOptions)
            .then(response => response.json())
            .then(login_json =>
            {
                if (login_json.status == "err")
                {
                    this.setState({"show_login_err": true, "login_err_message": "Inloggen niet gelukt. Probeer het opnieuw"});

                } else
                {
                    this.setState({'show_login_err': false});
                    console.log(login_json);
                    if (login_json.data.new_session)
                    {
                        window.app.handleLogin(login_json.data.user);
                        window.app.activateSession(login_json.data.session);
                    } else
                    {
                        window.app.handleLogin(login_json.data.user);
                        window.app.initSessionSelection(login_json.data.sessions);
                        window.app.nextPage();
                    }
                }
            });
    }

    sendAccClicked()
    {
        let errs = "";


        if (this.accNaam.current.value.trim() == "")
        {
            errs += "je naam ontbreekt<br/>";
        }


        if (!this.validateEmail(this.accEmail.current.value))
        {
            errs += "je e-mailadres is ongeldig<br/>";
        }


        if (this.accSchool.current.value.trim() == "")
        {
            errs += "je schoolnaam ontbreekt<br/>";
        }

        if (this.accSchooltype.current.value.trim() == "")
        {
            errs += "je schooltype ontbreekt<br/>";
        }

        if (this.accPlaats.current.value.trim() == "")
        {
            errs += "je schoolplaats ontbreekt<br/>";
        }

        /*if (this.accBrinnummer.current.value.trim() == "")
        {
            errs += "je brinnummer ontbreekt<br/>";
        }*/

        if (this.accGroep.current.value.trim() == "")
        {
            errs += "je groep ontbreekt<br/>";
        }

        if (this.accPassword1.current.value.length < 6 || this.accPassword1.current.value.length > 16)
        {
            errs += "je wachtwoord is niet tussen de 6 en 16 karakters<br/>";
        }
        else
        {
            if (this.accPassword1.current.value != this.accPassword2.current.value)
            {
                errs += "de wachtwoorden komen niet overeen<br/>";
            }
        }

        if (errs != "")
        {
            this.setState({"show_acc_err": true, "acc_err_message": "Corrigeer eerst onderstaande punten voor je verder kan gaan:" + errs});
            return;
        }


        this.setState({"show_acc_err": false});

        const formData = new FormData();
        formData.append("naam", this.accNaam.current.value.trim());
        formData.append("email", this.accEmail.current.value.trim());
        formData.append("school", this.accSchool.current.value.trim());
        formData.append("schooltype", this.accSchooltype.current.value.trim());
        formData.append("plaats", this.accPlaats.current.value.trim());
   //     formData.append("brinnummer", this.accBrinnummer.current.value.trim());
        formData.append("groep", this.accGroep.current.value.trim());
        formData.append("wachtwoord", this.accPassword1.current.value);
        formData.append("wachtwoord2", this.accPassword2.current.value);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/leerkracht_account", requestOptions)
            .then(response => response.json())
            .then(acc_json =>
            {

                if (acc_json.status == "err")
                {
                    this.setState({"show_acc_err": true, "acc_err_message": acc_json.data.message});

                } else
                {
                    this.setState({'show_acc_err': false});
                    if (acc_json.data.new_session)
                    {
                        window.app.handleLogin(acc_json.data.user);
                        window.app.activateSession(acc_json.data.session);
                    } else
                    {
                        window.app.handleLogin(acc_json.data.user);
                        window.app.initSessionSelection(acc_json.data.sessions);
                        window.app.nextPage();
                    }
                }
            });
    }


    render()
    {
        return (
            <div className={"tool__content__login__wrapper"}>

                {this.state.show_mode === 'login' && (
                    <>
                        <h1>Inloggen</h1>
                        <div className={"tool__content__login__content"} dangerouslySetInnerHTML={{__html: this.props.page.content}}></div>

                        <div className={"tool__content__login__content"}>
                            <h2>E-mailadres</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"email"} style={{"width": "35vw"}} ref={this.inputEmail}/><br/>
                            <h2>Wachtwoord</h2>
                            <input type={"password"} className={"tool__content__login__input"} name={"wachtwoord"} style={{"width": "35vw"}} ref={this.inputPassword}/><br/>

                            <a href="javascript:void(0)" className={"button"} onClick={this.loginClicked}>Nu inloggen</a> <a href="javascript:void(0)" className={"button"} onClick={this.showResetClicked}>Wachtwoord vergeten</a>
                            <br/>
                            <a href="javascript:void(0)" className={"button"} onClick={this.showAccClicked}>Account aanmaken</a>
                        </div>

                        {this.state.show_login_err && (
                            <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                                <p>{this.state.login_err_message}</p>
                            </div>
                        )}
                    </>
                )}


                {this.state.show_mode === 'reset' && (
                    <>
                        <h1>Nieuw wachtwoord aanvragen</h1>
                        <div className={"tool__content__login__content"}>Vul hieronder je e-mailadres in, je krijgt dan per e-mail een link om een nieuw wachtwoord aan te vragen.</div>

                    <div className={"tool__content__login__content"}>
                            <h2>E-mailadres</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"email"} style={{"width": "35vw"}} ref={this.resetEmail}/><br/>

                            <a href="javascript:void(0)" className={"button"} onClick={this.sendResetClicked}>Verstuur</a> <a href="javascript:void(0)" className={"button"} onClick={this.showLoginClicked}>Terug</a>
                        </div>

                        {this.state.show_reset_err && (
                            <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                                <p>{this.state.reset_err_message}</p>
                            </div>
                        )}
                    </>
                )}

                {this.state.show_mode === 'reset_send' && (
                    <>
                        <h1>Wachtwoord reset is verstuurd</h1>
                        <div className={"tool__content__login__content"}>
                                <p>Als je e-mailadres bij ons bekend is ontvang je binnen 15 minuten een e-mail met verdere instructie. Geen e-mail ontvangen? Controleer je SPAM box of stuur een e-mail naar support@onderzoekendlerenapp.nl.</p>

                                <a href="javascript:void(0)" className={"button"} onClick={this.showLoginClicked}>Terug naar inloggen</a>
                            </div>
                    </>
                )}

                {this.state.show_mode === 'acc' && (
                    <>
                        <h1>Leerkracht account aanmaken</h1>
                        <div className={"tool__content__login__content"}>
                            <p>Je kan hieronder een leerkracht account aanmaken voor Tool (onderzoekendlerenapp.nl, ontwerpendlerenapp.nl en spelendlerenapp.nl).</p>
                            <p>Alle velden zijn verplicht.</p>
                            <h2>Je naam</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"naam"} style={{"width": "35vw"}} ref={this.accNaam}/><br/>
                            <h2>Je school</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"school"} style={{"width": "35vw"}} ref={this.accSchool}/><br/>
                            <h2>Plaats van de school</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"plaats"} style={{"width": "35vw"}} ref={this.accPlaats}/><br/>


                            <h2>Type onderwijs</h2>
                            <select  name={"schooltype"} ref={this.accSchooltype}>
                                <option value="" >Maak een keuze</option>
                                <option value="po" >PO</option>
                                <option value="vo" >VO</option>
                                <option value="mbo">MBO</option>
                                <option value="hbo">HBO</option>
                                <option value="anders">Anders</option>
                            </select>
                            <h2>Je groep</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"groep"} style={{"width": "35vw"}} ref={this.accGroep}/><br/>

                            <h2>E-mailadres</h2>
                            <input type={"text"} className={"tool__content__login__input"} name={"email"} style={{"width": "35vw"}} ref={this.accEmail}/><br/>
                            <h2>Wachtwoord (tussen de 6 en 16 tekens, geen spaties)</h2>
                            <input type={"password"} className={"tool__content__login__input"} name={"wachtwoord1"} style={{"width": "35vw"}} ref={this.accPassword1}/><br/>
                            <h2>Wachtwoord opnieuw</h2>
                            <input type={"password"} className={"tool__content__login__input"} name={"wachtwoord2"} style={{"width": "35vw"}} ref={this.accPassword2}/><br/>

                            <a href="javascript:void(0)" className={"button"} onClick={this.sendAccClicked}>Verstuur</a> <a href="javascript:void(0)" className={"button"} onClick={this.showLoginClicked}>Terug</a>
                        </div>


                        {this.state.show_acc_err && (
                            <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                                <p dangerouslySetInnerHTML={{__html: this.state.acc_err_message}}></p>
                            </div>
                        )}
                    </>
                )}


            </div>

        );
    }

}
